export interface MemberCard {
  ACN: number;
  Area: string;
  CardStatus: number;
  ChangeDate: Date | string;
  ChangeReason: string;
  EntityTypeName: string;
  EventTypeName: string;
  ExternalRefNumber: string;
  MemberId: string;
  Name: string;
  PriceBand: string;
  ProductCode: string;
  ProductCodeDisplayName: string;
  Row: string;
  Seat: string;
  StartDate: Date | string;
  StandCode: string;
  StadiumCode: string;
  Services: string;
  Turnstile1: string;
  Turnstile2: string;
  Gate1: string;
  Gate2: string;
  Lounge: string;
  AvailableBalance: number;
  MemberSince?: string;
  DiscountLevel: string;
  RetailDiscountLevel: string;
}

/**
 * A factory function that creates MemberCard
 */
export function createMemberCard(params: Partial<MemberCard>) {
  return {} as MemberCard;
}

export function wipeBalance(memberCard: MemberCard): MemberCard {
  const { AvailableBalance, ...props } = memberCard;
  return { ...props, AvailableBalance: 0 };
}
